import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { API_URL } from '@/constants';
import Layout from '@/pages/Layout';

function LoginPage() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
      navigate('/');
    }
  }, [token, navigate]);

  return (
    <Layout header={false}>
      <div className="p-16 mx-auto text-center text-stone-500">
        <button
          className="w-1/2 bg-white text-slate-500 border-2 border-slate-400 px-4 py-2 rounded-md hover:bg-[#e3e0de] cursor-pointer"
          onClick={() => window.location.href = `${API_URL}/users/sign_in`}
        >
          Login
        </button>
      </div>
    </Layout>
  )
}

export default LoginPage
